import { useMemo } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";

const StatusSegment = ({
  isFirst,
  isLast,
  isActive,
  isError,
}: {
  isFirst?: boolean;
  isLast?: boolean;
  isActive: boolean;
  isError?: boolean;
}) => {
  const backgroundColor = useMemo(() => {
    if (isActive) {
      if (isError) {
        return "bg-danger-bold";
      }
      return "bg-accent-teal-bold";
    }
    return "bg-neutral";
  }, [isActive, isError]);

  return (
    <div
      className={cn(
        "h-2 w-6",
        isFirst && "rounded-l-full",
        isLast && "rounded-r-full",
        backgroundColor,
      )}
    />
  );
};

interface TransactionStatusProps {
  label?: string | null;
  progress: number;
  isError?: boolean;
}

export const TransactionStatus = ({
  label,
  progress,
  isError = false,
}: TransactionStatusProps) => (
  <Stack direction="row" align="center" gap={2}>
    <Stack align="start" gap={4} direction="row" className="gap-0.5">
      <StatusSegment isFirst isActive={progress >= 1} isError={isError} />
      <StatusSegment isActive={progress >= 2} isError={isError} />
      <StatusSegment isLast isActive={progress >= 3} isError={isError} />
    </Stack>
    {label && <Text>{label}</Text>}
  </Stack>
);
